export function parseThroughput(throughput: string | null | undefined): number | null {
	if (throughput == null) return null;
	const value = Number.parseFloat(throughput);
	return Number.isFinite(value) ? value : null;
}
